import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as notificationActions from '../../../actions/notificationActions';
import * as organisationActions from '../../../actions/organisationActions';
import * as userActions from '../../../actions/userActions';
import SecondaryMenu from '../../Global/Menus/SecondaryMenu';
import AccountMenu from '../AccountMenu';
import PageContainer from '../../Global/Containers/PageContainer';
import MaxWidthContainer from '../../Global/Containers/MaxWidthContainer';
import ChangeEmailForm from './ChangeEmailForm';
import ChangePasswordForm from './ChangePasswordForm';
import ChangePhoneNumberForm from './ChangePhoneNumberForm';
import ChangeEmailPreferencesForm from './ChangeEmailPreferencesForm';
import ChangeAgePreferencesForm from './ChangeAgePreferencesForm';
import LazyLoad from '../../Global/Loaders/LazyLoad';
import SpinLoader from '../../Global/Loaders/SpinLoader';

class YourBillingDetailsPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      values: {},
      changeEmailSubmitting: false,
      changePasswordSubmitting: false,
      changePhoneNumberSubmitting: false,
      changeEmailPreferencesSubmitting: false,
      changeAgePreferencesSubmitting: false,
    };
  }

  componentDidMount() {
    this.props.actions.getAgeCategories();
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.loggedInUser !== nextProps.loggedInUser) {
      this.setState({ loading: false });
    }

    if (this.props.loggedInUser.email_address !== nextProps.loggedInUser.email_address) {
      this.setState({ changeEmailSubmitting: false });
    }

    if ((this.props.loggedInUser.area_code_1 !== nextProps.loggedInUser.area_code_1) || (this.props.loggedInUser.tel_no_1 !== nextProps.loggedInUser.tel_no_1)) {
      this.setState({ changePhoneNumberSubmitting: false });
    }

    if (this.props.loggedInUser.email_preferences !== nextProps.loggedInUser.email_preferences) {
      this.setState({ changeEmailPreferencesSubmitting: false });
    }

    if (this.props.loggedInUser.ages !== nextProps.loggedInUser.ages) {
      this.setState({ changeAgePreferencesSubmitting: false });
    }
  }

  handleChangeEmailSubmit = (values) => {
    this.setState({ changeEmailSubmitting: true });
    this.props.actions.updateEmail(values.email, values.confirmEmail);
  }

  handleChangePasswordSubmit = (values) => {
    this.setState({ changePasswordSubmitting: true });
    this.props.actions.updatePassword(values.password, values.newPassword, values.confirmNewPassword)
    // We can't do this in componentWillReceiveProps like the others because we don't want to store the password in Redux
    .then(() => this.setState({ changePasswordSubmitting: false }));
  }

  handleChangePhoneNumberSubmit = (values) => {
    this.setState({ changePhoneNumberSubmitting: true });
    this.props.actions.updatePhoneNumber(values.areaNo1, values.areaCode1, values.telNo1);
  }

  handleChangeEmailPreferencesSubmit = (values) => {
    this.setState({ changeEmailPreferencesSubmitting: true });
    this.props.actions.updateEmailPreferences(values.emailPreferences);
  }

  handleChangeAgePreferencesSubmit = (values) => {
    this.setState({ changeAgePreferencesSubmitting: true });
    this.props.actions.updateCoachAgePreferences(values.coachAgeGroups);
  }

  render() {
    const { loggedInUser, organisation } = this.props;
    const { loading, changeEmailSubmitting, changePasswordSubmitting, changePhoneNumberSubmitting, changeEmailPreferencesSubmitting, changeAgePreferencesSubmitting } = this.state;

    return (
      <div id="your-plan-page">
        <PageContainer classes="bg-white">
          <SecondaryMenu>
            <AccountMenu active="details" billingEnabled={loggedInUser.billing_enabled} />
          </SecondaryMenu>

          <MaxWidthContainer>
            <h1 className="like-h2 m-t-5 m-b-1">Account Details</h1>
            <p className="m-b-5 like-h5 color-grey max-width-paragraph">
              Here you can view and change your current email address, phone number and email preferences as well as change your password. If you require additional help please contact us at <a href="mailto:help@thecoachingmanual.com?Subject=Help from 'Account Details' page" className="link">help@thecoachingmanual.com</a>.
            </p>

            {loading ? (
              <LazyLoad><SpinLoader black /></LazyLoad>
            ) : (
              <div className="row">
                <div className="col-md-6">
                  <ChangeEmailForm
                    currentEmail={loggedInUser.email_address}
                    onSubmit={this.handleChangeEmailSubmit}
                    submitting={changeEmailSubmitting}
                  />

                  <ChangePhoneNumberForm
                    loggedInUser={loggedInUser}
                    onSubmit={this.handleChangePhoneNumberSubmit}
                    submitting={changePhoneNumberSubmitting}
                  />

                  <ChangeAgePreferencesForm
                    agePreferences={loggedInUser.age_groupings}
                    ageCategories={organisation.availableAgeCategories || []}
                    onSubmit={this.handleChangeAgePreferencesSubmit}
                    submitting={changeAgePreferencesSubmitting}
                  />
                </div>

                <div className="col-md-6">
                  <ChangePasswordForm
                    onSubmit={this.handleChangePasswordSubmit}
                    submitting={changePasswordSubmitting}
                  />

                  <ChangeEmailPreferencesForm
                    emailPreferences={loggedInUser.email_preferences}
                    onSubmit={this.handleChangeEmailPreferencesSubmit}
                    submitting={changeEmailPreferencesSubmitting}
                  />
                </div>
              </div>
            )}
          </MaxWidthContainer>
        </PageContainer>
      </div>
    );
  }
}

YourBillingDetailsPage.propTypes = {
  loggedInUser: PropTypes.object.isRequired,
  organisation: PropTypes.object.isRequired,
  actions: PropTypes.object.isRequired,
};

function mapStateToProps(state) {
  return {
    loggedInUser: state.loggedInUser,
    organisation: state.organisation,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(Object.assign({}, notificationActions, userActions, organisationActions), dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(YourBillingDetailsPage);



// WEBPACK FOOTER //
// ./library/app/components/Account/AccountDetails/AccountDetailsPage.js